<template>
    <div class="photo-lower-bar-button-group">
        <div class="photo-lower-bar-button" v-on:click="showModal('project-delete-confirmation-modal')">
            <SVGProjectsDelete class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding">Удалить</span>
        </div>
        <div class="photo-lower-bar-button" v-on:click="showModal('project-copy-modal')">
            <SVGProjectsCopy class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding">Сделать копию</span>
        </div>
    </div>
</template>

<script>
    import {modalMethods} from "../../common.js";
    import SVGProjectsDelete from "../../SVG/SVGProjectsDelete";
    import SVGProjectsCopy from "../../SVG/SVGProjectsCopy";

    export default {
        name: "LeftLowerBarProjects",
        mixins: [modalMethods],
        components: {
            SVGProjectsCopy,
            SVGProjectsDelete
        }
    }
</script>

<style scoped>

</style>
